<template>
    <div class="taxes">
        <div class="box-white-wrapper">
            <vs-table search :data="taxes" pagination max-items="20">
                <template slot="header">
                    <vs-button color="primary" @click="openModal()" type="border" icon="library_add">Agregar Impuesto</vs-button>
                </template>
                <template slot="thead">
                    <vs-th sort-key="name">Producto </vs-th>
                    <vs-th sort-key="rate">Arancel </vs-th>
                    <vs-th sort-key="statusName" class="width-20">Estado </vs-th>
                    <vs-th sort-key="id"></vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].name">
                        <div class="d-flex">
                            <div :class="['circle', data[indextr].permission === 0 ? 'st-secondary' : 'st-warning']"></div>
                            {{data[indextr].name }}
                        </div>
                    </vs-td>
                     <vs-td :data="data[indextr].rate">
                        {{data[indextr].rate}}
                    </vs-td>
                     <vs-td :data="data[indextr].statusname">
                        <div :class="['circle', data[indextr].status === 1 ? 'success' : 'danger']"></div>
                    </vs-td>
                    <vs-td :data="data[indextr].code">
                        <div class="table-actions">
                            <a href="javascript:void(0)" @click="editTax(data[indextr].code)"><feather type="edit-2"/></a>
                        </div>
                    </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <transition name="fade">
                <ModalBasic :show="ModalActive">
                    <div class="modal-header" slot="modal-header">{{ ModalTitle }}</div>
                    <div class="modal-body" slot="modal-body">
                        <form>
                            <div :class="['form-input',{'has-error': $v.tax.name.$error }]">
                                <vs-input label="Nombre" v-model.trim="$v.tax.name.$model"/>
                                <span class="error-text" v-if="$v.tax.name.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div :class="['form-input',{'has-error': $v.tax.rate.$error }]">
                                <vs-input label="Porcentaje" v-model.trim="$v.tax.rate.$model" @keypress="isNumber($event)"/>
                                <span class="error-text" v-if="$v.tax.rate.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div :class="['form-input',{'has-error': $v.tax.permission.$error}]">
                                <label for="">Permiso Adicional</label>
                                <select-input :options="permissions" v-model="$v.tax.permission.$model"></select-input>
                            </div>
                            <div :class="['form-input',{'has-error': tax.permissionCost == ''}]" v-if="tax.permission.id == 1">
                                <vs-input label="Costo del permiso" v-model.trim="tax.permissionCost" @keypress="isNumber($event)"/>
                                <span class="error-text" v-if="tax.permissionCost == ''"><feather type="info" />Este campo es requerido</span>
                            </div>
                            <div :class="['form-input',{'has-error': $v.tax.status.$error}]">
                                <label for="">Estado</label>
                                <select-input :options="status" v-model="$v.tax.status.$model"></select-input>
                                <span class="error-text" v-if="$v.tax.status.$error"><feather type="info" />Este campo es requerido</span>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer" slot="modal-footer">
                        <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                        <vs-button :disabled="confirmStatus || $v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                            @click="handleRequestTax" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
                    </div>
                </ModalBasic>
            </transition>
        </div>
    </div>
</template>
<script>
import TaxModel from '@/models/TaxModel';
import TaxDataService from "@/services/TaxDataService";
import ModalBasic from '@/components/Modal/Basic.vue'
import { required } from 'vuelidate/lib/validators'
import {helper} from '@/helpers/utils'
import SelectInput from '@/components/Form/Select-Input.vue'
export default {
    name: 'taxes',
    mixins: [helper],
    components: {
      ModalBasic,
      SelectInput
    },
    data() {
      return {
        tax: new TaxModel(),
        taxes: [],
        permissions: [
          {
            id: 0,
            name: "No"
          },
          {
            id: 1,
            name: "Si"
          },
        ],
        status: [
          {
            id: 1,
            name: "Activo"
          },
          {
            id: 0,
            name: "Inactivo"
          },
        ],
        ModalTitle: 'Nuevo Impuesto',
        ModalActive: false,
        confirmStatus: false,
        isUpdating: false,
      }
    },
    validations: {
        tax: 
            { 
                name: { required },
                rate: { required },
                permission: { required },
                status: { required }
            },
    },
    beforeMount() {
        this.$Progress.start();
    },
    mounted () {
      this.retrieveTaxes();
    },
    methods:{
        openModal () {
          this.tax    = new TaxModel()
          this.ModalActive = true
          this.isUpdating  = false
          this.$v.$reset()
        },
        closeModal () {
            this.ModalTitle  = 'Nuevo Impuesto'
            this.ModalActive = false
            this.tax    = new TaxModel()
            this.$v.$reset()
        },
        editTax (id) {
          console.log(id)
          this.ModalTitle  = "Editar Impuesto"
          this.tax = this.searchTax(id);
          this.ModalActive = true
          this.isUpdating  = true
        },
        retrieveTaxes() {
            TaxDataService.getAll()
            .then(response => {
                this.taxes = response.data;
                this.$Progress.finish()
                console.log(response.data);
            })
            .catch(e => {
                console.log(e);
                this.$Progress.finish()
                this.$vs.notify({title:'Error!',text:'Error obteniendo los impuestos!',color:'danger',icon:'error_outline'})
            });
        },
        handleRequestTax(){
            this.$v.$touch()
            if (this.$v.$invalid) return;
            if (!this.isUpdating) {
                this.saveTax()
            } else {
                this.updateTax()
            }
        },
        saveTax(){
            const that = this
            console.log(this.tax);
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            TaxDataService.create(that.tax)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Creado!',text:'El impuesto fue creado exitosamente!',color:'success',icon:'check'})
                that.tax = new TaxModel()
                this.$v.$reset()
                this.retrieveTaxes()
            })
            .catch(e => {
                console.log(e)
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.confirmStatus = false
                that.$vs.notify({title:'Información!',text:'Error creando el impuesto',color:'danger',icon:'error_outline'})                
            });
        },
        updateTax(){
            const that = this
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            TaxDataService.update(that.tax)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Información!',text:'El impuesto fue modificado exitosamente!',color:'success',icon:'check'})
                that.tax = new TaxModel()
                this.retrieveTaxes()
                this.$v.$reset()
            })
            .catch(e => {
                console.log(e)
                that.ModalActive = false
                that.confirmStatus = false
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.$vs.notify({title:'Información!',text:'Error actualizando el impuesto',color:'danger',icon:'error_outline'})
            });
        },
        searchTax (_taxID) {
            let objTax = this.taxes.filter((item) => {
              return _taxID === item.code
            })
            objTax =  objTax[0]
            let _objPerms  = { id: objTax.permission, name: objTax.permission == 0 ? 'No' : 'Si' }
            let _objStatus = { id: objTax.status, name: objTax.statusname }
            let tax = new TaxModel(objTax.code, objTax.name, objTax.description, objTax.rate, _objPerms, objTax.permissionCost, _objStatus);
  
            return tax
        }
    }
}
</script>
